// Copyright 2005 David Caldwell <david@porkrind.org> -*- c -*-
// Copyright 2005 Jim Radford <radford@blackbean.org>

var Alert = require('./alert');
var prnt = require('./print'), print=prnt.print;
var lib = require('./lib');
var dom = require('./dom'), doc=dom.doc, on_load=dom.on_load, px=dom.px;

//x=document.createElement(""); for (var i in x) { print(i); }

var level_string = document.URL.split('?')[1];
if (level_string == undefined)
    level_string = "1,3:5:3:5:2,1:1_1,3:5:3:4:2,2:1"; // bat

var levels = [
    { name: "bat",                         data: "1,3:5:3:5:2,1:1_1,3:5:3:4:2,2:1" },
    { name: "heart",                       data: "4:6:7:7:7:7:7:6:4:_:2,2:4,4:9:9:9:7:5:3:1" },
    { name: "diamond",                     data: "1:3:5:7:9:7:5:3:1:_:1:3:5:7:9:7:5:3:1" },
    { name: "club",                        data: "2:4:4,1:2,2,2:10:2,2,2:4,1:4:2:_1:3:3:2,1,2:9:9:2,1,2:1:3:5" },
    { name: "another club",                data: "2:4:4,1:2,2,2:10:10:2,2,2:4,1:4:2_2:4:4:2,2,2:10:10:2,2,2:2:4:6" },
    { name: "spade",                       data: "3:5:6,1:6,2:10:6,2:6,1:5:3:_1:3:5:7:9:9:9:2,1,2:3:5" },
    { name: "\"A\"",                       data: "3:3:4:3,1:2,1:3,1:4:3:3:_1:3:1,1:2,2:1,1:2,2:7:2,2:1,1:1,1" },
    { name: "\"B\"",                       data: ":10:1,1,1:1,1,1:1,1,1:2,3,2:3,4:::_5:1,2:1,1:1,2:5:1,2:1,1:1,1:1,2:5" },
    { name: "\"C\"",                       data: ":6:2,2:2,2:1,1:1,1:1,1:2,2::_5:2,1:2:1:1:1:1:2:2,1:5" },
    { name: "balloon?",                    data: "2:4:1,4:4,1:2,1:1_3:2,2:5:3:1,1:3" },
    { name: "Penguin?",                    data: "1,2:2,1,1:1,5:6:2,1:1_2:2,1:2:4:1,4:1,2:4" },
    { name: "key",                         data: "1:4:2,1:3:1:1:1:3:2,2:3_1:3:8,1:3,3:1,1,1:2" },
    { name: "syringe",                     data: "1:1:4:1,1:1,1:1,1:1,1:2,2:2:4_1:6,1:3,2:1,2:6,1:1" },
    { name: "Flower from the Netherlands", data: "3,3:3,2:9:3,1:3,1:2_1,1,1:5:5:3:1:1,1:1,1,2:1,2:3:1" },
    { name: "Cereal bowl?",                data: "4:2:1,2:1,1:1:1,1:1:1,1,2:2:4_1,1,1:1,1,1,1:1,1,1:2,1,2:2,2:6" },
    { name: "Mushroom",                    data: "3,2:1,2,1,1:1,2,2,1:5,1:2,4:3_2:1,2:1,4:4,1:2,3:1,1:1,1:1,1:1,1:3" },
    { name: "Dog",                         data: "2:3:1,2:5:2:1_1:2:1,3:4:3:1,1" },
    { name: "Lighter",                     data: "2:3:3:6:1,1:2,1,1:1,2,1:2,5_1:2,1,1:3,1,1:3,1:6:1,1:1,1:1,1:5" },
    { name: "House",                       data: "1:5:2,1:2,3:2,1,1:5:1_1:3:2,2:2,2:5:1,1,1:1,3" },
    { name: "Plug",                        data: "1,1,1:1,1,2:5,1:1,1,1:1,1,2:3,1:1,1:6_3:3,1:1,3:3,1,1:3,1:1:4,1:2,4" },
    { name: "Elvis/Face",                  data: "2:2,2:5,3:2,1,1:2,1:7,1:4,1:7:2_7:8:1,3:2,3:1,1,1:1,1,2:2,1,2:1,1:5" },
    { name: "Pitcher",                     data: "2,4,1:1,1,3:4,2:1,1:4,2:1,1,3:6,1:2,1:1,1:3_6:1,1,1,2:1,1,2,1:2,3,1:1,1,1:1,1,1:1,2:2,2:2,2:7" },
    { name: "Smiley",                      data: "6:2,2:2,2:1,2,2,1:1,1,1:1,1,1:1,2,2,1:2,2:2,2:6_6:2,2:2,2:1,1,1,1:1,1,1,1:1,1:1,1,1,1:2,4,2:2,2:6" },
    { name: "Dog",                         data: "2:2:3:8,1:8:4,1:5:4:1,3:4_1:1:3:5:6,1:4,1:5,1:7:1,4:6" },
    { name: "Cupid's arrow",               data: "3:1,1:1,1:1,1,1:1,1,1:1,2:3:1:3:1,1_2,2:1,1,1:1,1,2:1,6:1,1,2:3" },
    { name: "High Heeled Shoe",            data: "2:1,1:2,1:3,2:2,2:1,2:1,1:1,5:8_3:1,1:2,1:1,1:2,3:1,1,2:1,2,2:1,2,2:4,2" },
    { name: "??? bombomb?",                data: "9:9:9:6,1:5,1,1:4,1,1:3,1,1:2,1,2:2,2:5_1:8:9:7,2:6,1:5,1,1:4,1,1:3,1,1,2:3,2:7" },
    { name: "Church",                      data: "4:2:2,1:2:2,1:6:1,3:5,3:1,3:6_1:3:1:3:5:6,2:6,1:1,1,1,1:1,1,2,1,1:1,1,1,1" },
    { name: "Fish",                        data: "4,3:5,4:3,3:1,1,1:1,1:2,2:3,1,3:4,4:1,3,4:2,6_2,6:3,3,1:4,4:3,2:1,1,2:1:1,3:3,4:4,5:3,6" },
    { name: "Runner",                      data: "3,1:1,3:1,1,2:7:7:1,2:1,1:3,1:1:2_2:1,3:1,2:8:2,1:2,1:4,2:2,3,1:1:2" },
    { name: "Cat",                         data: "1,2:4,1,1:3,6:7:3,6:4,4:1,3:2:3,1:2,3_1,1:2,2:5:2,1,2,1:5,2:3,1:6,2:1,5,1:8:2,4" },
    { name: "Mailbox",                     data: "4:1,1:1,1,1:1,1:2,1:1,3,6:6,1:2,1,1:2,1,1:5_3:3:1:7:1,1,1,1:1,2,1:1,1,1,1:1,1,1:5,4:1:1:1:1:1:1" },
    { name: "Dog doing \"shake\"",         data: "4:1,3:4:5:4,1:1,7:7,1:3,1:2,1:2,2_2:2:4:1,5:1,3:1,7:1,5,1:6:3,1:6" },
    { name: "Apple",                       data: "7:9:9:7:8:1,1,2:1,2,1:1,2:2,2:6_1:2,1,2:3,1,1,2:6,1:5,1:5,1,1:5,1,1:5,2:6,2:3,3" },
    { name: "pin-wheel",                   data: "5,1:4,2:3,1,1:3,1:4,4:1,3:1,1,3:2,4:1,5_1,5:2,1,1:3,1,1:6:4,4:6:1,1,3:1,1,2:5,1" },
    { name: "Bread",                       data: "4:2,2:2,9:1,1:1,1:1,1:1,1:1,1:1,1:2,9:3,2,1:7,1:7,1:14:4_11:2,5:2,5:1,4:1,4:2,5:2,5:1,1,1:1,1,1:1,1,1:1,1,1:1,1,1:1,1,1:1,1,1:12" },
    { name: "Pumpkin",                     data: "8:10:3,4:2,3:1,2:1,9:1,3,5:2,2,3:4,2:1,2:3,2:1,9:1,3:1,5:9_2:2:1:4,2,3:3,5,1:3,1,1,1:2,2,1,1:2,1,1,1:2,1,1,1:2,2,1,1:2,2,1,2:3,2,1,2:4,3,5:14:4,3,3" },
    { name: "trick?",                      data: "5:2,1:1,1:1,1:1,1:1,1:1,1:8:12,1:12,2:4,22:3,2,3,3,2,9:3,4,3,3,7:2,1,1,1,1,4,5,1:1,2,3,13,1:2,1,2,9,7:5,4,9:22:4,6,2:4,6,1:3,6:3,4:4,3:3,5:3,1,1:1,1,2,1:1,1,1,4:1,2,9:3,10:11_5:4,2:3,1:1,2,1:1,1,1:1,1:5,7:1,1,7,1:16,2:5,8,3:4,2,4:3,1,2:2,3,3,1,1:2,9,4,6:1,14,7,3:1,9,7,3:11,2,7,4:5,2,5,7:9,4,4:4,4,1,4:2,1,4,1,3:2,2,2,3:2,2,2,2:3,3,1:8,1:3,3:3,3:3,3:4,4:5,5" }, 
    { name: "Bulldog",                     data: "13,5:3,6,3:2,5,2:2,9:2,2,2:3,3,6:2,1,2,2,1,2,5:1,2,1,6,1,3:2,6,2,4,4:1,1,1,2,1,1,4:4,1,1,3,4:3,6,1,1,1,4:1,4,1,1,3,4:1,1,1,2,1,1,4:2,6,1,3,4:2,1,1,2,2,1,4:1,2,3,4,3:4,1,2,1,5:1,6:2,4,1:5,1,1,2:2,13,2:2,10,3:2,5,4:3,6,6:13,6,3:19,2:16:16:17,1_8,2,12:7,1,11:2,1,1,1,6:1,1,1,5:1,2,3,3,2,5:1,1,2,2,2,5:4,3,9:4,1,5,1,9:4,1,1,3,1,1,9:4,2,1,3,1,2,9:4,1,2,1,2,1,9:2,1,1,1,3,1,1,2,6:1,2,2,2,1,3,5:5,3,1,2,4:3,7,4:1,2,2,2,1,4:5,3,4,1,1:1,1,5,2,1,1:4,5,2:1,9,1,1:2,1,1,1,2,1:9,1:1:1,1,1:1,1,1:1,2,2,2:1,12,4:2,12,5:3,8,4:3,8,4,1" }
];

function create_level_list() {
    var url = document.URL.match(/^([^?]*)(\?.*)?$/)[1];
    print("url="+url+"\n");
    var span = document.getElementById("levels");
    var ul = document.createElement("ul");
    for (var i in levels) {
        var li = document.createElement("li");
        var a = document.createElement("a");
        a.href = url + "?" + levels[i].data;
        a.appendChild(document.createTextNode(levels[i].name));
        li.appendChild(a);
        ul.appendChild(li);
    }
    span.appendChild(ul);
}
create_level_list();


var X=0, Y=1;
function level(level_string) {
    print("level_string=\""+level_string+"\"\n");
    var _ = level_string.split("_");

    this.clump = [ _[0].split(":"), _[1].split(":") ];
    this.clump_max = [ [], [] ];
    var sum = [ 0, 0 ];
    for (var xy in this.clump) {
        this.clump_max[xy] = 0;
        for (var i in this.clump[xy]) {
            this.clump[xy][i] = this.clump[xy][i].split(",");
            this.clump_max[xy] = Math.max(this.clump_max[xy], this.clump[xy][i].length);
            for (var j in this.clump[xy][i])
                sum[xy] += this.clump[xy][i][j] = Number(this.clump[xy][i][j]);
        }
    }
    if (sum[0] != sum[1])
        alert("Bad sums: " + sum[1] + "(row) != " + sum[0] + "(col)");

    this.grid = [];
    for (var i=0; i<this.clump[X].length; i++)
        this.grid[i] = new Array(this.clump[Y].length);

    this.undo = new Array();
}

level.prototype.create_board = function(div) {
    var me = this;
    this.table =  document.createElement("table");
    var tbody =  document.createElement("tbody");
    this.table.cellSpacing = 0;
    this.table.style.cursor = "crosshair";
    //this.table.border = 1;
    this.cell = new Array();
    for (var x=0; x<this.clump[X].length + this.clump_max[Y]; x++)
        this.cell[x] = new Array(this.clump[Y].length + this.clump_max[X]);
    
    for (var y=-this.clump_max[X]; y<this.clump[Y].length; y++) {
        var tr = document.createElement("tr");
        for (var x=-this.clump_max[Y]; x<this.clump[X].length; x++) {
            var td = document.createElement("td");
            this.cell[x+this.clump_max[Y]][y+this.clump_max[X]] = td;
            td.style.border = "solid";
            td.style.borderWidth = "1px";
            td.style.borderTop="none";
            td.style.borderLeft="none";
            if ((x + 1) % 5 == 0)
                td.style.borderRightWidth = "3px";
            if ((y + 1) % 5 == 0)
                td.style.borderBottomWidth = "3px";
            if (x<0 && y<0) {
                td.bgColor = "#555555";
            } else if (x<0 || y<0) {
                td.bgColor = "#999999";
            } else
                this.update(x,y);
            td.style.borderColor = "#555555";
            td.align = "center";

            var s = "."; // should be nbsp
            
            if (x<0 && y>=0 && this.clump[Y][y][x+this.clump[Y][y].length] != undefined)
                s = this.clump[Y][y][x+this.clump[Y][y].length];

            if (y<0 && x>=0 && this.clump[X][x][y+this.clump[X][x].length] != undefined)
                s = this.clump[X][x][y+this.clump[X][x].length];

            if (s == ".")
                td.style.color = td.bgColor;

            td.appendChild(document.createTextNode(s));
            tr.appendChild(td);

            var install_solver = 0; // Temporarily disable solving.
            if (x>=0 && y>=0)
                this.install_handers(td,x,y);
            else if (install_solver) {
              if (x>=0 && y<0)
                this.install_clumps(td,X,x);
              else if (x<0 && y>=0)
                this.install_clumps(td,Y,y);
              else if (x<0 && y<0)
                this.install_solver(td);
            }
        }
        tbody.appendChild(tr);
    }
    this.table.appendChild(tbody);
    div.appendChild(this.table);

    // Why doesn't this work??? Not rendered yet??
    var w=-1;
    for (var x in this.cell)
        for (var y in this.cell[x])
            w = Math.max(w, Math.max(this.cell[x][y].width, this.cell[x][y].height));
    print("w="+w+"\n");

    var size = Math.max(this.cell.length, this.cell[0].length) >= 20 ? 20 : 35;
    for (var x in this.cell)
        for (var y in this.cell[x])
            this.cell[x][y].style.width = this.cell[x][y].style.height = px(size);
}

level.prototype.string_rep_from_cells = function() {
    let row_clumps = [];
    for (var y=0; y<this.grid[0].length; y++)
        row_clumps.push(this.clumps_from_line(this.line_from_row(y)).join(","));

    let col_clumps = [];
    for (var x=0; x<this.grid.length; x++)
        col_clumps.push(this.clumps_from_line(this.line_from_col(x)).join(","));

    return col_clumps.join(':')+'_'+row_clumps.join(':');
}

level.prototype.install_handers = function(td, x, y) {
    td.onmouseover = function(event) { // print("mouse over "+x+" "+y+"\n");
        if (this.dragging_x != undefined && this.dragging_y != undefined ) {
            this.grid[x][y] = this.grid[this.dragging_x][this.dragging_y];
            this.update(x,y);
        }
        return false;
    }.bind(this);
    td.onmouseup = function(event) {  // print("mouse up "+x+" "+y+"\n");
        this.dragging_x = this.dragging_y = undefined;
        this.won() && new Alert(doc.el("div", {},
                                       doc.el("p", {align:"center"}, doc.text("You've won!!!\n")),
                                       doc.el("p", {style: {fontSize:"small"} }, doc.text("Admire the picture, then choose one of the "+
                                                                                          "other pictures and try your skill again. "/*+
                                                                                          "Finish them all? Try creating your own in the editor."*/))),
                                { title: "Congratulations", goaway:true });
        return false;
    }.bind(this);
    td.onmousedown = function(event) { // print("mouse down "+x+" "+y+"\n");
        this.push_state();
        this.grid[x][y] = { undefined:1, 1:0, 0:undefined } [ this.grid[x][y] ];
        this.update(x,y);
        this.dragging_x = x; this.dragging_y = y;
        this.old_onmouseup = document.onmouseup;
        document.onmouseup = function() { // print("document mouse up "+x+" "+y+"\n");
            if (this.dragging_x != undefined && this.dragging_x != undefined)
                this.pop_state();
            this.dragging_x = this.dragging_y = undefined;
            document.onmouseup = this.old_onmouseup;
        }.bind(this);
        return false;
    }.bind(this);
}

level.prototype.update = function(x,y) {
    var td = this.cell[x+this.clump_max[Y]][y+this.clump_max[X]];
    td.bgColor = td.style.color =
       { undefined:"#888888", 0:"#ffffff", 1:"#000000" } [ this.grid[x][y] ];
}

level.prototype.update_all = function() {
    for (var y=0; y<this.grid[0].length; y++)
        for (var x=0; x<this.grid.length; x++)
            this.update(x,y);
}

level.prototype.push_state = function() {
    var current = this.grid.concat();
    for (var x=0; x<this.grid.length; x++)
        current[x] = this.grid[x].concat();
    this.undo.push(current);
}

level.prototype.pop_state = function() {
    if (this.undo.length > 0) {
        this.grid = this.undo.pop();
        this.update_all();
    } else
        print("nothing to undo!\n");
}

level.prototype.line_match = function(line, clumps) {
    var re=[];
    for (var i=0; i<clumps.length; i++)
        re.push("b{" + clumps[i] + "}");
    re = "^w*" + re.join("w+") + "w*$";

    var state = "";
    for (var i=0; i<line.length; i++)
        state += { undefined:"_", 1:"b", 0:"w" } [ line[i] ];

    //print("state: " + state + " re: " + re + " " + (state.match(re) ? "matched" : "") + "\n");
    return state.match(re);
}

level.prototype.clumps_from_line = function(line) {
    var clump = 0;
    var clumps = [];
    for (let c of line)
        if (c == 1)
            clump++;
        else if (clump) {
            clumps.push(clump);
            clump = 0;
        }
    if (clump)
        clumps.push(clump);
    return clumps;
}

level.prototype.line_from_row = function(row) {
    var line=[]; for (var x=0; x<this.grid.length; x++) line.push(this.grid[x][row]);
    return line;
}

level.prototype.line_from_col = function(col) {
    return this.grid[col];
}

level.prototype.won = function() {
    for (var y=0; y<this.grid[0].length; y++)
        if (!this.line_match(this.line_from_row(y), this.clump[Y][y]))
            return false;
    for (var x=0; x<this.grid.length; x++)
        if (!this.line_match(this.line_from_col(x), this.clump[X][x]))
            return false;
    return true;
}

function ri(line, clumps) {
    this.line = line;
    var sum = 0; for (var i=0; i<clumps.length; i++) sum += clumps[i];
    this.clumps = clumps;
    this.n = Array(clumps.length); for (var i=0; i<this.n.length; i++) this.n[i] = 0; 
    this.n_sum = 0;
    this.n_sum_max = line.length - sum - clumps.length + 1;
    this.n_total=1; for (var i=1; i<=this.n.length; i++) this.n_total *= (this.n_sum_max+i)/i;
    this.array = Array(line.length);
    this.array_update();
}

ri.prototype.toString = function() { return this.clumps + " " + this.n.join("+") + "=" + this.n_sum + " max: " + this.n_sum_max + " array: " + this.array; }

ri.prototype.step = function() { // step the "rile iterator" by one
    for (var i=this.n.length-1; i>=0; i--) {
        if (++this.n_sum <= this.n_sum_max && ++this.n[i])
            break;
        this.n_sum -= this.n[i]+1;
        this.n[i] = 0;
    }
    this.array_update();
    return this.n_sum; // 0 at the end of a cycle
}

ri.prototype.array_update = function() {
    for (var start=0, i=0; i<this.clumps.length; i++) {
        for (var c=0; c<this.n[i]; c++)       this.array[start++] = 0;
        for (var c=0; c<this.clumps[i]; c++)  this.array[start++] = 1;
        if  (start < this.line.length)        this.array[start++] = 0;
    }
    while (start < this.line.length)            this.array[start++] = 0;
}

ri.prototype.compatible = function() {
    for (var i=0; i<this.line.length; i++)
        if (this.line[i] != undefined && this.array[i] != this.line[i])
                return false;
    return true;
}

level.prototype.move_next = function(line, clumps) {
    var it = new ri(line, clumps);
    var and = null;
    do {
        if (!it.compatible())
            continue;
        if (and == null)
            and = it.array.concat();
        else
            for (i in it.array)
                if (and[i] ^ it.array[i])
                    and[i] = undefined;
    } while (it.step());
    for (var i=0; i<line.length; i++)
       if (line[i] == undefined && and[i] != undefined)
          return and; // only return and if there is something new
    return null;
}

level.prototype.grid_line = function(xy, index) {
    if (xy == X) return this.grid[index];
    else for(var line=[], x=0; x<this.grid.length; x++)
        line[x] = this.grid[x][index];
    return line;
}
level.prototype.grid_line_set = function(xy, index, line) {
    if (xy == X) this.grid[index] = line;
    else for(var x=0; x<this.grid.length; x++)
        this.grid[x][index] = line[x];
}

level.prototype.install_clumps = function(td, xy, i) {
    td.onclick = function() {
        var line = this.move_next(this.grid_line(xy, i), this.clump[xy][i]);
        if (line != null) {
            this.grid_line_set(xy, i, line);
            this.update_all();
        }
    }.bind(this);
}

level.prototype.solve_step = function() {
    var done = true;
    for (var xy in this.clump)
        for (var i=0; i<this.clump[xy].length; i++) {
            var line = this.move_next(this.grid_line(xy, i), this.clump[xy][i]);
            done &= line == null;
            if (line != null)
                this.grid_line_set(xy, i, line);
        }
    return done;
}
level.prototype.solve = function() { while (!this.solve_step()) {} }

level.prototype.install_solver = function(td) {
    td.onclick = function() {
        var done = this.solve_step();
        print("done: " + done + "\n");
        this.update_all();
    }.bind(this);
}

on_load(function() {
    var l = new level(level_string);
    var undo = document.getElementById("undo");
    undo.onclick = function() { l.pop_state(); };
    l.create_board(document.getElementById("board"));
});

// Copyright 2005 David Caldwell <david@porkrind.org> -*- c -*-
// Copyright 2005 Jim Radford <radford@blackbean.org>

var Alert = require('./alert');
var prnt = require('./print'), print=prnt.print;
var lib = require('./lib');
var dom = require('./dom'), doc=dom.doc, on_load=dom.on_load, px=dom.px;

//x=document.createElement(""); for (var i in x) { print(i); }

var level_string = document.URL.split('?')[1];
if (level_string == undefined)
    level_string = "1,3:5:3:5:2,1:1_1,3:5:3:4:2,2:1"; // bat

var levels = [
    { name: "bat",                         data: "1,3:5:3:5:2,1:1_1,3:5:3:4:2,2:1" },
    { name: "heart",                       data: "4:6:7:7:7:7:7:6:4:_:2,2:4,4:9:9:9:7:5:3:1" },
    { name: "diamond",                     data: "1:3:5:7:9:7:5:3:1:_:1:3:5:7:9:7:5:3:1" },
    { name: "club",                        data: "2:4:4,1:2,2,2:10:2,2,2:4,1:4:2:_1:3:3:2,1,2:9:9:2,1,2:1:3:5" },
    { name: "another club",                data: "2:4:4,1:2,2,2:10:10:2,2,2:4,1:4:2_2:4:4:2,2,2:10:10:2,2,2:2:4:6" },
    { name: "spade",                       data: "3:5:6,1:6,2:10:6,2:6,1:5:3:_1:3:5:7:9:9:9:2,1,2:3:5" },
    { name: "\"A\"",                       data: "3:3:4:3,1:2,1:3,1:4:3:3:_1:3:1,1:2,2:1,1:2,2:7:2,2:1,1:1,1" },
    { name: "\"B\"",                       data: ":10:1,1,1:1,1,1:1,1,1:2,3,2:3,4:::_5:1,2:1,1:1,2:5:1,2:1,1:1,1:1,2:5" },
    { name: "\"C\"",                       data: ":6:2,2:2,2:1,1:1,1:1,1:2,2::_5:2,1:2:1:1:1:1:2:2,1:5" },
    { name: "balloon?",                    data: "2:4:1,4:4,1:2,1:1_3:2,2:5:3:1,1:3" },
    { name: "Penguin?",                    data: "1,2:2,1,1:1,5:6:2,1:1_2:2,1:2:4:1,4:1,2:4" },
    { name: "key",                         data: "1:4:2,1:3:1:1:1:3:2,2:3_1:3:8,1:3,3:1,1,1:2" },
    { name: "syringe",                     data: "1:1:4:1,1:1,1:1,1:1,1:2,2:2:4_1:6,1:3,2:1,2:6,1:1" },
    { name: "Flower from the Netherlands", data: "3,3:3,2:9:3,1:3,1:2_1,1,1:5:5:3:1:1,1:1,1,2:1,2:3:1" },
    { name: "Cereal bowl?",                data: "4:2:1,2:1,1:1:1,1:1:1,1,2:2:4_1,1,1:1,1,1,1:1,1,1:2,1,2:2,2:6" },
    { name: "Mushroom",                    data: "3,2:1,2,1,1:1,2,2,1:5,1:2,4:3_2:1,2:1,4:4,1:2,3:1,1:1,1:1,1:1,1:3" },
    { name: "Dog",                         data: "2:3:1,2:5:2:1_1:2:1,3:4:3:1,1" },
    { name: "Lighter",                     data: "2:3:3:6:1,1:2,1,1:1,2,1:2,5_1:2,1,1:3,1,1:3,1:6:1,1:1,1:1,1:5" },
    { name: "House",                       data: "1:5:2,1:2,3:2,1,1:5:1_1:3:2,2:2,2:5:1,1,1:1,3" },
    { name: "Plug",                        data: "1,1,1:1,1,2:5,1:1,1,1:1,1,2:3,1:1,1:6_3:3,1:1,3:3,1,1:3,1:1:4,1:2,4" },
    { name: "Elvis/Face",                  data: "2:2,2:5,3:2,1,1:2,1:7,1:4,1:7:2_7:8:1,3:2,3:1,1,1:1,1,2:2,1,2:1,1:5" },
    { name: "Pitcher",                     data: "2,4,1:1,1,3:4,2:1,1:4,2:1,1,3:6,1:2,1:1,1:3_6:1,1,1,2:1,1,2,1:2,3,1:1,1,1:1,1,1:1,2:2,2:2,2:7" },
    { name: "Smiley",                      data: "6:2,2:2,2:1,2,2,1:1,1,1:1,1,1:1,2,2,1:2,2:2,2:6_6:2,2:2,2:1,1,1,1:1,1,1,1:1,1:1,1,1,1:2,4,2:2,2:6" },
    { name: "Dog",                         data: "2:2:3:8,1:8:4,1:5:4:1,3:4_1:1:3:5:6,1:4,1:5,1:7:1,4:6" },
    { name: "Cupid's arrow",               data: "3:1,1:1,1:1,1,1:1,1,1:1,2:3:1:3:1,1_2,2:1,1,1:1,1,2:1,6:1,1,2:3" },
    { name: "High Heeled Shoe",            data: "2:1,1:2,1:3,2:2,2:1,2:1,1:1,5:8_3:1,1:2,1:1,1:2,3:1,1,2:1,2,2:1,2,2:4,2" },
    { name: "??? bombomb?",                data: "9:9:9:6,1:5,1,1:4,1,1:3,1,1:2,1,2:2,2:5_1:8:9:7,2:6,1:5,1,1:4,1,1:3,1,1,2:3,2:7" },
    { name: "Church",                      data: "4:2:2,1:2:2,1:6:1,3:5,3:1,3:6_1:3:1:3:5:6,2:6,1:1,1,1,1:1,1,2,1,1:1,1,1,1" },
    { name: "Fish",                        data: "4,3:5,4:3,3:1,1,1:1,1:2,2:3,1,3:4,4:1,3,4:2,6_2,6:3,3,1:4,4:3,2:1,1,2:1:1,3:3,4:4,5:3,6" },
    { name: "Runner",                      data: "3,1:1,3:1,1,2:7:7:1,2:1,1:3,1:1:2_2:1,3:1,2:8:2,1:2,1:4,2:2,3,1:1:2" },
    { name: "Cat",                         data: "1,2:4,1,1:3,6:7:3,6:4,4:1,3:2:3,1:2,3_1,1:2,2:5:2,1,2,1:5,2:3,1:6,2:1,5,1:8:2,4" },
    { name: "Mailbox",                     data: "4:1,1:1,1,1:1,1:2,1:1,3,6:6,1:2,1,1:2,1,1:5_3:3:1:7:1,1,1,1:1,2,1:1,1,1,1:1,1,1:5,4:1:1:1:1:1:1" },
    { name: "Dog doing \"shake\"",         data: "4:1,3:4:5:4,1:1,7:7,1:3,1:2,1:2,2_2:2:4:1,5:1,3:1,7:1,5,1:6:3,1:6" },
    { name: "Apple",                       data: "7:9:9:7:8:1,1,2:1,2,1:1,2:2,2:6_1:2,1,2:3,1,1,2:6,1:5,1:5,1,1:5,1,1:5,2:6,2:3,3" },
    { name: "pin-wheel",                   data: "5,1:4,2:3,1,1:3,1:4,4:1,3:1,1,3:2,4:1,5_1,5:2,1,1:3,1,1:6:4,4:6:1,1,3:1,1,2:5,1" },
    { name: "Bread",                       data: "4:2,2:2,9:1,1:1,1:1,1:1,1:1,1:1,1:2,9:3,2,1:7,1:7,1:14:4_11:2,5:2,5:1,4:1,4:2,5:2,5:1,1,1:1,1,1:1,1,1:1,1,1:1,1,1:1,1,1:1,1,1:12" },
    { name: "Pumpkin",                     data: "8:10:3,4:2,3:1,2:1,9:1,3,5:2,2,3:4,2:1,2:3,2:1,9:1,3:1,5:9_2:2:1:4,2,3:3,5,1:3,1,1,1:2,2,1,1:2,1,1,1:2,1,1,1:2,2,1,1:2,2,1,2:3,2,1,2:4,3,5:14:4,3,3" },
    { name: "trick?",                      data: "5:2,1:1,1:1,1:1,1:1,1:1,1:8:12,1:12,2:4,22:3,2,3,3,2,9:3,4,3,3,7:2,1,1,1,1,4,5,1:1,2,3,13,1:2,1,2,9,7:5,4,9:22:4,6,2:4,6,1:3,6:3,4:4,3:3,5:3,1,1:1,1,2,1:1,1,1,4:1,2,9:3,10:11_5:4,2:3,1:1,2,1:1,1,1:1,1:5,7:1,1,7,1:16,2:5,8,3:4,2,4:3,1,2:2,3,3,1,1:2,9,4,6:1,14,7,3:1,9,7,3:11,2,7,4:5,2,5,7:9,4,4:4,4,1,4:2,1,4,1,3:2,2,2,3:2,2,2,2:3,3,1:8,1:3,3:3,3:3,3:4,4:5,5" }, 
    { name: "Bulldog",                     data: "13,5:3,6,3:2,5,2:2,9:2,2,2:3,3,6:2,1,2,2,1,2,5:1,2,1,6,1,3:2,6,2,4,4:1,1,1,2,1,1,4:4,1,1,3,4:3,6,1,1,1,4:1,4,1,1,3,4:1,1,1,2,1,1,4:2,6,1,3,4:2,1,1,2,2,1,4:1,2,3,4,3:4,1,2,1,5:1,6:2,4,1:5,1,1,2:2,13,2:2,10,3:2,5,4:3,6,6:13,6,3:19,2:16:16:17,1_8,2,12:7,1,11:2,1,1,1,6:1,1,1,5:1,2,3,3,2,5:1,1,2,2,2,5:4,3,9:4,1,5,1,9:4,1,1,3,1,1,9:4,2,1,3,1,2,9:4,1,2,1,2,1,9:2,1,1,1,3,1,1,2,6:1,2,2,2,1,3,5:5,3,1,2,4:3,7,4:1,2,2,2,1,4:5,3,4,1,1:1,1,5,2,1,1:4,5,2:1,9,1,1:2,1,1,1,2,1:9,1:1:1,1,1:1,1,1:1,2,2,2:1,12,4:2,12,5:3,8,4:3,8,4,1" }
];

function create_level_list() {
    var url = document.URL.match(/^([^?]*)(\?.*)?$/)[1];
    print("url="+url+"\n");
    var span = document.getElementById("levels");
    var ul = document.createElement("ul");
    for (var i in levels) {
        var li = document.createElement("li");
        var a = document.createElement("a");
        a.href = url + "?" + levels[i].data;
        a.appendChild(document.createTextNode(levels[i].name));
        li.appendChild(a);
        ul.appendChild(li);
    }
    span.appendChild(ul);
}
create_level_list();


var X=0, Y=1;
function level(level_string) {
    print("level_string=\""+level_string+"\"\n");
    var _ = level_string.split("_");

    this.clump = [ _[0].split(":"), _[1].split(":") ];
    this.clump_max = [ [], [] ];
    var sum = [ 0, 0 ];
    for (var xy in this.clump) {
        this.clump_max[xy] = 0;
        for (var i in this.clump[xy]) {
            this.clump[xy][i] = this.clump[xy][i].split(",");
            this.clump_max[xy] = Math.max(this.clump_max[xy], this.clump[xy][i].length);
            for (var j in this.clump[xy][i])
                sum[xy] += this.clump[xy][i][j] = Number(this.clump[xy][i][j]);
        }
    }
    if (sum[0] != sum[1])
        alert("Bad sums: " + sum[1] + "(row) != " + sum[0] + "(col)");

    this.grid = [];
    for (var i=0; i<this.clump[X].length; i++)
        this.grid[i] = new Array(this.clump[Y].length);

    this.undo = new Array();
}

level.prototype.create_board = function(div) {
    var me = this;
    this.table =  document.createElement("table");
    var tbody =  document.createElement("tbody");
    this.table.cellSpacing = 0;
    this.table.style.cursor = "crosshair";
    //this.table.border = 1;
    this.cell = new Array();
    for (var x=0; x<this.clump[X].length + this.clump_max[Y]; x++)
        this.cell[x] = new Array(this.clump[Y].length + this.clump_max[X]);
    
    for (var y=-this.clump_max[X]; y<this.clump[Y].length; y++) {
        var tr = document.createElement("tr");
        for (var x=-this.clump_max[Y]; x<this.clump[X].length; x++) {
            var td = document.createElement("td");
            this.cell[x+this.clump_max[Y]][y+this.clump_max[X]] = td;
            td.style.border = "solid";
            td.style.borderWidth = "1px";
            td.style.borderTop="none";
            td.style.borderLeft="none";
            if ((x + 1) % 5 == 0)
                td.style.borderRightWidth = "3px";
            if ((y + 1) % 5 == 0)
                td.style.borderBottomWidth = "3px";
            if (x<0 && y<0) {
                td.bgColor = "#555555";
            } else if (x<0 || y<0) {
                td.bgColor = "#999999";
            } else
                this.update(x,y);
            td.style.borderColor = "#555555";
            td.align = "center";

            var s = "."; // should be nbsp
            
            if (x<0 && y>=0 && this.clump[Y][y][x+this.clump[Y][y].length] != undefined)
                s = this.clump[Y][y][x+this.clump[Y][y].length];

            if (y<0 && x>=0 && this.clump[X][x][y+this.clump[X][x].length] != undefined)
                s = this.clump[X][x][y+this.clump[X][x].length];

            if (s == ".")
                td.style.color = td.bgColor;

            td.appendChild(document.createTextNode(s));
            tr.appendChild(td);

            var install_solver = 0; // Temporarily disable solving.
            if (x>=0 && y>=0)
                this.install_handers(td,x,y);
            else if (install_solver) {
              if (x>=0 && y<0)
                this.install_clumps(td,X,x);
              else if (x<0 && y>=0)
                this.install_clumps(td,Y,y);
              else if (x<0 && y<0)
                this.install_solver(td);
            }
        }
        tbody.appendChild(tr);
    }
    this.table.appendChild(tbody);
    div.appendChild(this.table);

    // Why doesn't this work??? Not rendered yet??
    var w=-1;
    for (var x in this.cell)
        for (var y in this.cell[x])
            w = Math.max(w, Math.max(this.cell[x][y].width, this.cell[x][y].height));
    print("w="+w+"\n");

    var size = Math.max(this.cell.length, this.cell[0].length) >= 20 ? 20 : 35;
    for (var x in this.cell)
        for (var y in this.cell[x])
            this.cell[x][y].style.width = this.cell[x][y].style.height = px(size);
}

level.prototype.string_rep_from_cells = function() {
    let row_clumps = [];
    for (var y=0; y<this.grid[0].length; y++)
        row_clumps.push(this.clumps_from_line(this.line_from_row(y)).join(","));

    let col_clumps = [];
    for (var x=0; x<this.grid.length; x++)
        col_clumps.push(this.clumps_from_line(this.line_from_col(x)).join(","));

    return col_clumps.join(':')+'_'+row_clumps.join(':');
}

level.prototype.install_handers = function(td, x, y) {
    td.onmouseover = function(event) { // print("mouse over "+x+" "+y+"\n");
        if (this.dragging_x != undefined && this.dragging_y != undefined ) {
            this.grid[x][y] = this.grid[this.dragging_x][this.dragging_y];
            this.update(x,y);
        }
        return false;
    }.bind(this);
    td.onmouseup = function(event) {  // print("mouse up "+x+" "+y+"\n");
        this.dragging_x = this.dragging_y = undefined;
        this.won() && new Alert(doc.el("div", {},
                                       doc.el("p", {align:"center"}, doc.text("You've won!!!\n")),
                                       doc.el("p", {style: {fontSize:"small"} }, doc.text("Admire the picture, then choose one of the "+
                                                                                          "other pictures and try your skill again. "/*+
                                                                                          "Finish them all? Try creating your own in the editor."*/))),
                                { title: "Congratulations", goaway:true });
        return false;
    }.bind(this);
    td.onmousedown = function(event) { // print("mouse down "+x+" "+y+"\n");
        this.push_state();
        this.grid[x][y] = { undefined:1, 1:0, 0:undefined } [ this.grid[x][y] ];
        this.update(x,y);
        this.dragging_x = x; this.dragging_y = y;
        this.old_onmouseup = document.onmouseup;
        document.onmouseup = function() { // print("document mouse up "+x+" "+y+"\n");
            if (this.dragging_x != undefined && this.dragging_x != undefined)
                this.pop_state();
            this.dragging_x = this.dragging_y = undefined;
            document.onmouseup = this.old_onmouseup;
        }.bind(this);
        return false;
    }.bind(this);
}

level.prototype.update = function(x,y) {
    var td = this.cell[x+this.clump_max[Y]][y+this.clump_max[X]];
    td.bgColor = td.style.color =
       { undefined:"#888888", 0:"#ffffff", 1:"#000000" } [ this.grid[x][y] ];
}

level.prototype.update_all = function() {
    for (var y=0; y<this.grid[0].length; y++)
        for (var x=0; x<this.grid.length; x++)
            this.update(x,y);
}

level.prototype.push_state = function() {
    var current = this.grid.concat();
    for (var x=0; x<this.grid.length; x++)
        current[x] = this.grid[x].concat();
    this.undo.push(current);
}

level.prototype.pop_state = function() {
    if (this.undo.length > 0) {
        this.grid = this.undo.pop();
        this.update_all();
    } else
        print("nothing to undo!\n");
}

level.prototype.line_match = function(line, clumps) {
    var re=[];
    for (var i=0; i<clumps.length; i++)
        re.push("b{" + clumps[i] + "}");
    re = "^w*" + re.join("w+") + "w*$";

    var state = "";
    for (var i=0; i<line.length; i++)
        state += { undefined:"_", 1:"b", 0:"w" } [ line[i] ];

    //print("state: " + state + " re: " + re + " " + (state.match(re) ? "matched" : "") + "\n");
    return state.match(re);
}

level.prototype.clumps_from_line = function(line) {
    var clump = 0;
    var clumps = [];
    for (let c of line)
        if (c == 1)
            clump++;
        else if (clump) {
            clumps.push(clump);
            clump = 0;
        }
    if (clump)
        clumps.push(clump);
    return clumps;
}

level.prototype.line_from_row = function(row) {
    var line=[]; for (var x=0; x<this.grid.length; x++) line.push(this.grid[x][row]);
    return line;
}

level.prototype.line_from_col = function(col) {
    return this.grid[col];
}

level.prototype.won = function() {
    for (var y=0; y<this.grid[0].length; y++)
        if (!this.line_match(this.line_from_row(y), this.clump[Y][y]))
            return false;
    for (var x=0; x<this.grid.length; x++)
        if (!this.line_match(this.line_from_col(x), this.clump[X][x]))
            return false;
    return true;
}

function ri(line, clumps) {
    this.line = line;
    var sum = 0; for (var i=0; i<clumps.length; i++) sum += clumps[i];
    this.clumps = clumps;
    this.n = Array(clumps.length); for (var i=0; i<this.n.length; i++) this.n[i] = 0; 
    this.n_sum = 0;
    this.n_sum_max = line.length - sum - clumps.length + 1;
    this.n_total=1; for (var i=1; i<=this.n.length; i++) this.n_total *= (this.n_sum_max+i)/i;
    this.array = Array(line.length);
    this.array_update();
}

ri.prototype.toString = function() { return this.clumps + " " + this.n.join("+") + "=" + this.n_sum + " max: " + this.n_sum_max + " array: " + this.array; }

ri.prototype.step = function() { // step the "rile iterator" by one
    for (var i=this.n.length-1; i>=0; i--) {
        if (++this.n_sum <= this.n_sum_max && ++this.n[i])
            break;
        this.n_sum -= this.n[i]+1;
        this.n[i] = 0;
    }
    this.array_update();
    return this.n_sum; // 0 at the end of a cycle
}

ri.prototype.array_update = function() {
    for (var start=0, i=0; i<this.clumps.length; i++) {
        for (var c=0; c<this.n[i]; c++)       this.array[start++] = 0;
        for (var c=0; c<this.clumps[i]; c++)  this.array[start++] = 1;
        if  (start < this.line.length)        this.array[start++] = 0;
    }
    while (start < this.line.length)            this.array[start++] = 0;
}

ri.prototype.compatible = function() {
    for (var i=0; i<this.line.length; i++)
        if (this.line[i] != undefined && this.array[i] != this.line[i])
                return false;
    return true;
}

level.prototype.move_next = function(line, clumps) {
    var it = new ri(line, clumps);
    var and = null;
    do {
        if (!it.compatible())
            continue;
        if (and == null)
            and = it.array.concat();
        else
            for (i in it.array)
                if (and[i] ^ it.array[i])
                    and[i] = undefined;
    } while (it.step());
    for (var i=0; i<line.length; i++)
       if (line[i] == undefined && and[i] != undefined)
          return and; // only return and if there is something new
    return null;
}

level.prototype.grid_line = function(xy, index) {
    if (xy == X) return this.grid[index];
    else for(var line=[], x=0; x<this.grid.length; x++)
        line[x] = this.grid[x][index];
    return line;
}
level.prototype.grid_line_set = function(xy, index, line) {
    if (xy == X) this.grid[index] = line;
    else for(var x=0; x<this.grid.length; x++)
        this.grid[x][index] = line[x];
}

level.prototype.install_clumps = function(td, xy, i) {
    td.onclick = function() {
        var line = this.move_next(this.grid_line(xy, i), this.clump[xy][i]);
        if (line != null) {
            this.grid_line_set(xy, i, line);
            this.update_all();
        }
    }.bind(this);
}

level.prototype.solve_step = function() {
    var done = true;
    for (var xy in this.clump)
        for (var i=0; i<this.clump[xy].length; i++) {
            var line = this.move_next(this.grid_line(xy, i), this.clump[xy][i]);
            done &= line == null;
            if (line != null)
                this.grid_line_set(xy, i, line);
        }
    return done;
}
level.prototype.solve = function() { while (!this.solve_step()) {} }

level.prototype.install_solver = function(td) {
    td.onclick = function() {
        var done = this.solve_step();
        print("done: " + done + "\n");
        this.update_all();
    }.bind(this);
}

on_load(function() {
    var l = new level(level_string);
    var undo = document.getElementById("undo");
    undo.onclick = function() { l.pop_state(); };
    l.create_board(document.getElementById("board"));
});

